<template>
  <div class="drop-image" :class="{placeholderImg: !this.image}">
    <div class="top-action for-image d-none">
      <b-button-group>
        <b-button class="el-move-action" v-b-popover.hover.left="`Déplacer l'élément`"><font-awesome-icon :icon="['fas', 'expand-arrows-alt']" /></b-button>
        <b-button
          @click="deleteElement"
        ><font-awesome-icon :icon="['fas', 'trash']" /></b-button>
      </b-button-group>
    </div>
    <image-input :imageProps="data" class="image-input" v-model="image">
      <div slot="activator" class="img-drop" v-if="!this.image && !this.data.src" :style="style">
        <font-awesome-icon :icon="['fas', 'file-image']" size="lg" />
        <span  v-if="this.data.type === 'logo'" class="mt-2"><b>Logo</b></span>
        <span  v-else class="mt-2"><b>Image</b></span>
      </div>
      <b-row v-else align-h="center" slot="activator">
        <b-col cols="12">
          <logoElement
            v-if="this.data.type === 'logo'"
            :center="true"
            :element="this.image ? {src: this.image.imageURL, dimension: this.image.dimension} : this.data"
          />
          <image-element
            v-else
            :element="this.image ? {src: this.image.imageURL} : this.data"
          />
        </b-col>
      </b-row>
    </image-input>
    <b-row v-if="this.image" align-h="center" class="mt-2">
      <b-col cols="12">
        <b-button v-if="!pending()" variant="outline-primary"
          @click="upload(image.formData, elindex, image.dimension)"
        >
          Valider
        </b-button>
        <b-button v-else variant="primary">
          <b-spinner small type="grow"></b-spinner> En attente...
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import imageInput from '../../imageUploader/imageInput'
import logoElement from '../display/logoElement'
import imageElement from '../display/imageElement'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    imageInput,
    logoElement,
    imageElement
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    elindex: Number
  },
  data () {
    return {
      image: null,
      style: { width: '100%' }
    }
  },
  created () {
    if (this.data.size) {
      this.style = {
        height: this.data.size.h + 'px',
        width: this.data.size.w + 'px'
      }
    }
  },
  methods: {
    ...mapActions(['uploadImage', 'setPending']),
    ...mapGetters(['pending']),
    openEditElementModal () {

    },
    deleteElement () {
      this.$emit('deleteElement', this.elindex)
    },
    async upload (formData, elindex, dimension) {
      this.setPending(true)
      const res = await this.uploadImage({formData})
      this.$emit('updateImageSrc', {elindex, src: res, dimension})
      this.setPending(false)
      // this.image = null
    }
  }

}
</script>

<style lang="scss" scoped>

  .columnActive .for-image {
    display:inline-block !important;
  }

  .drop-image {
  padding: 20px;
  margin-bottom: 20px;
  /*border: 1px solid #2b3085;*/
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background-color: #FFF;
  text-align: center;
  font-size: 14px;
  border-radius: 3px 3px 0 0;
  .top-action {
    position: absolute;
    top: 0;
    left: 50%;
    height: 25px;
    margin-bottom: 20px;
    text-align: center;
    background-color: #d2d3e5;
    button{
      background-color: transparent;
      border: none;
      color: #2b3085;
      border-radius: 3px;
      font-weight: normal;
      box-shadow: none !important;
      padding-left: 5px;
      padding-right: 5px;
      height: 25px;
      line-height: 25px;
      margin-top: -2px;
      &:hover{
        color: #2b3085;
      }
      &:active{
        background-color: #2b3085;
        color: #fff;
      }
    }
  }

  &.placeholderImg {
    .image-input{
      /*max-width: 130px;*/
    }
  }
  .image-input{
    margin: auto;
    margin-top: 20px;
    cursor: pointer;

    .img-drop{
      max-width: 130px;
      padding: 10px;
      border: 1px dashed #2b3085;
      box-sizing: border-box;
      background-color: whitesmoke;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-style: italic;
      font-family: "Noto Sans", sans-serif;
      margin: auto;
      color: #2b3085;
      span {
        color: #000;
      }
    }
  }
  .upload-info{
    font-size: 14px;
    font-style: italic;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/imageDrop.vue